import { MockNotification } from './MockNotification';
import { tryDisableAllWebPushNotifications } from '../actions/disableAllWebPushNotifications';
import { saveWebPushNotificationsOptionsQuick } from '../actions/saveWebPushNotificationsOptions';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { OptionDescription } from 'owa-options-controls';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-options-strings';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { isBrowserChrome, isMac } from 'owa-user-agent';
import {
    getLocalWebPushUserSettingStore,
    LocalWebPushUserSetting,
} from 'owa-webpush-notifications';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    WebPushNotificationsOptions,
} from 'owa-outlook-service-options';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';

export interface WebPushNotificationsFullProps {
    userOptions?: WebPushNotificationsOptions;
    localWebPushUserSetting?: LocalWebPushUserSetting;
}

@reactive({
    userOptions: () =>
        getOptionsForFeature<WebPushNotificationsOptions>(
            OwsOptionsFeatureType.WebPushNotifications
        ),
    localWebPushUserSetting: () => getLocalWebPushUserSettingStore(),
})
export default class NotificationOptionsFull extends React.Component<
    WebPushNotificationsFullProps,
    {}
> {
    render() {
        let { userOptions, localWebPushUserSetting } = this.props;
        let hostname = getHostLocation().hostname;

        return (
            <div>
                <OptionDescription>
                    {format(strings.webpushFullSettingsBody, hostname)}
                </OptionDescription>
                <MockNotification
                    browser={isBrowserChrome() ? 'chrome' : 'firefox'}
                    os={isMac() ? 'osx' : 'windows'}
                    title={strings.webpushMockNotificationSender}
                    body={strings.webpushMockNotificationSubject}
                    url={hostname}
                />
                <OptionDescription>When {hostname} is closed:</OptionDescription>
                <Toggle
                    onText={strings.webpushFullSettingsNewMessageOption}
                    offText={strings.webpushFullSettingsNewMessageOption}
                    checked={userOptions.enabled && localWebPushUserSetting.enabled}
                    onChanged={saveWebPushNotificationsOptionsQuick}
                />
                <TooltipHost
                    content={
                        !userOptions.enabled ? strings.webpushFullSettingsDisableAllToolTip : ''
                    }>
                    <Link
                        onClick={tryDisableAllWebPushNotifications}
                        disabled={!userOptions.enabled}>
                        {strings.webpushFullSettingsDisableAll}
                    </Link>
                </TooltipHost>
            </div>
        );
    }
}
